export default "__VITE_ASSET__KMwMulQj__"